<div class="d-inline-flex">
  <div class="plus-icon">
    <co-image width="24" height="24" type="svg" key="add" imageSet="{{imageSetGreen}}"></co-image>
  </div>
  <div class="product-button">
    <co-image width="32" height="32" type="svg" key="sticky" imageSet="{{imageSet}}"></co-image>
  </div>
</div>